const initialForm = {
    email: {
        name: 'email',
        isTouched: false,
        isValid: false,
        value: ''
    },
    subscriptionNumber: {
        name: 'subscriptionNumber',
        isTouched: false,
        isValid: false,
        value: ''
    },
    postalCode: {
        name: 'postalCode',
        isTouched: false,
        isValid: false,
        value: ''
    },
    cancellationDate: {
        name: 'cancellationDate',
        isTouched: false,
        isValid: false,
        value: ''
    },
    cancellationType: {
        name: 'cancellationType',
        isTouched: false,
        isValid: false,
        value: ''
    }
};

export { initialForm };
//# sourceMappingURL=initial-form.js.map
